import qs from 'qs'

import { ReportsType } from '../enums/reportsType'
import { ReportOptions } from '../types/reportOptions'

export const getReportRequestQueryParams = (
  reportUrl: ReportsType,
  options?: ReportOptions,
): Record<string, string | number | boolean> | undefined => {
  switch (reportUrl) {
    case ReportsType.TrialBalance:
    case ReportsType.ProfitAndLoss: {
      const { compareCount, compareWith, hideZeroes, period, ytd } = (options || {}) as ReportOptions

      return {
        ...(compareCount ? { compareCount } : {}),
        ...(compareWith ? { compareWith } : {}),
        ...(hideZeroes !== undefined ? { hideZeroes } : { hideZeroes: false }),
        ...(period ? { period } : {}),
        ...(ytd !== undefined ? { ytd } : { ytd: false }),
      }
    }
    case ReportsType.BalanceSheet: {
      const { compareCount, compareWith, hideZeroes, period, ytd } = (options || {}) as ReportOptions

      return {
        ...(compareCount ? { compareCount } : {}),
        ...(compareWith ? { compareWith } : { compareWith: 'month' }),
        ...(hideZeroes !== undefined ? { hideZeroes } : { hideZeroes: false }),
        ...(period ? { period } : {}),
        ...(ytd !== undefined ? { ytd } : { ytd: false }),
      }
    }
    default:
      return undefined
  }
}

export const getQueryStringFromReportParams = (reportType: ReportsType, options?: ReportOptions): string => {
  return qs.stringify(getReportRequestQueryParams(reportType, options))
}
